import { alpha, createTheme, Theme, ThemeOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Theme {
    colors: {
      primary: {
        fade: string;
        fade_Light: string;
        fade_Dark: string;
        fadeBlack?: string;
        fadeBlack_Light?: string;
        fadeBlack_Dark?: string;
      };
      secondary: {
        fade: string;
        fade_Light: string;
        fade_Dark: string;
      };
    };
  }
  interface ThemeOptions {
    colors: {
      primary: {
        fade: string;
        fade_Light: string;
        fade_Dark: string;
        fadeBlack?: string;
        fadeBlack_Light?: string;
        fadeBlack_Dark?: string;
      };
      secondary: {
        fade: string;
        fade_Light: string;
        fade_Dark: string;
      };
    };
  }
}

declare module "@mui/material/styles/createPalette" {
  export interface PaletteOptions {
    captivatePrimary: {
      main: string;
      contrastText: string | undefined;
    };
    captivateSecondary: {
      main: string;
      contrastText: string | undefined;
    };
    motivatePrimary: {
      main: string;
      contrastText: string | undefined;
    };
    motivateSecondary: {
      main: string;
      contrastText: string | undefined;
    };
    candidateStatus: {
      green: string;
      blue: string;
      purple: string;
      yellow: string;
      red: string;
    };
  }
  export interface Palette {
    captivatePrimary: {
      main: string;
      contrastText: string | undefined;
    };
    captivateSecondary: {
      main: string;
      contrastText: string | undefined;
    };
    motivatePrimary: {
      main: string;
      contrastText: string | undefined;
    };
    motivateSecondary: {
      main: string;
      contrastText: string | undefined;
    };
    candidateStatus: {
      green: string;
      blue: string;
      purple: string;
      yellow: string;
      red: string;
    };
  }
}

export const themeOptions: ThemeOptions = {
  colors: {
    primary: {
      fade: alpha("#00bcd4", 0.08),
      fade_Light: alpha("#00bcd4", 0.03),
      fade_Dark: alpha("#00bcd4", 0.16),
      fadeBlack: "rgba(0,0,0,0.12)",
      fadeBlack_Light: "rgba(0,0,0,0.03)",
      fadeBlack_Dark: "rgba(0,0,0,0.09)",
    },
    secondary: {
      fade: alpha("#445BAB", 0.08),
      fade_Light: alpha("#445BAB", 0.03),
      fade_Dark: alpha("#445BAB", 0.16),
    },
  },
  palette: {
    primary: {
      main: "#00af4a",
      contrastText: "#fff",
    },
    secondary: {
      main: "#445BAB",
      contrastText: "#fff",
    },
    error: {
      main: "#e84f41",
    },
    background: {
      default: "#f5f5f5",
    },
    text: {
      primary: "#464646",
      secondary: "rgba(0, 0, 0, 0.65)",
      disabled: "#A2A3A5",
    },
    info: {
      main: "#464646",
    },
    captivatePrimary: {
      main: "#445bab",
      contrastText: "#fff",
    },
    captivateSecondary: {
      main: "#1cace8",
      contrastText: "#fff",
    },
    motivatePrimary: {
      main: "#a652a0",
      contrastText: "#fff",
    },
    motivateSecondary: {
      main: "#ed7044",
      contrastText: "#fff",
    },
    candidateStatus: {
      green: "#39b54a",
      blue: "#5865ae",
      purple: "#a5519f",
      yellow: "#d4cf31",
      red: "#e76d42",
    },
    divider: "rgba(0, 0, 0, 0.12)",
  },
  typography: {
    fontFamily: "Open Sans",
    h1: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    h2: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    h3: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "Barlow Condensed",
      fontWeight: 600,
    },
    button: {
      fontFamily: "Open Sans",
      fontWeight: 700,
      fontSize: "0.8rem",
    },
    subtitle1: {
      fontFamily: "Open Sans",
      fontWeight: 700,
    },
    body1: {
      fontSize: "0.9rem",
      fontWeight: 300,
    },
    body2: {
      fontSize: "0.9rem",
    },
    subtitle2: {
      fontWeight: 700,
    },
  },
};

declare module "@mui/material/Chip" {
  interface ChipPropsColorOverrides {
    captivatePrimary: true;
    captivateSecondary: true;
    motivatePrimary: true;
    motivateSecondary: true;
  }
}

const theme: Theme = createTheme(themeOptions);
export default theme;
